import {useQuery} from "@tanstack/react-query";
import {FeeModel} from "../models/user.models";
import FeeService from "../services/FeeService";


const getFee = async (price: number): Promise<FeeModel> => {
  const { data } = await FeeService.getFee(price)
  return data;
};

const useFee = (price?: number) => {

  return useQuery<FeeModel, string>({
    queryKey: ["fee", price],
    queryFn: () => getFee(price!),
    enabled: price !== undefined && price > 0,
    staleTime: Infinity
  });

}
export default useFee;

